import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { ChevronDown, Lock } from 'lucide-react';

export const HeroSection = ({ onStart }) => {
  return (
    <section
      className="min-h-screen relative flex flex-col items-center justify-center px-6 overflow-hidden"
      data-testid="hero-section"
    >
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="inline-block text-xs font-medium tracking-[0.2em] uppercase text-[hsl(var(--teal))] mb-6">
            Structured Self-Assessment
          </span>
        </motion.div>

        <motion.h1
          className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-foreground leading-[1.1] mb-8"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        >
          What kind of experience{' '}
          <span className="italic text-[hsl(var(--gold))]">actually works for you?</span>
        </motion.h1>

        <motion.p
          className="text-base sm:text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto mb-6"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
        >
          Sex isn't just what happens. It's how and why it happens.
          <br className="hidden sm:block" />
          What works for you depends on the intent behind it,
          not just the act itself.
        </motion.p>

        <motion.p
          className="text-sm text-muted-foreground/70 leading-relaxed max-w-xl mx-auto mb-12"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        >
          The same act can feel completely different depending on context, energy, and intent.
          This helps you see what actually makes the difference.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
        >
          <Button
            onClick={onStart}
            data-testid="start-assessment-btn"
            className="rounded-full px-8 py-6 text-base font-medium bg-[hsl(var(--gold))] text-white hover:bg-[hsl(var(--gold)/0.9)] transition-transform hover:scale-[0.98] active:scale-[0.96]"
          >
            Begin
          </Button>
        </motion.div>

        <motion.div
          className="flex items-center justify-center gap-2 mt-8 text-xs text-muted-foreground/60"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <Lock className="w-3 h-3" />
          <span>Private by design. Your responses stay in your browser.</span>
        </motion.div>
      </div>

      <motion.div
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.8 }}
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
        >
          <ChevronDown className="w-5 h-5 text-muted-foreground/40" />
        </motion.div>
      </motion.div>
    </section>
  );
};
